import React from 'react';

// material-ui
import { Divider, List, Typography } from '@material-ui/core';

// project imports
import NavItem from './../NavItem';
import { GenericCardProps } from '../../../../../../types/index';
import NavCollapse from '../NavCollapse';

//-----------------------|| SIDEBAR MENU LIST GROUP ||-----------------------//

export interface NavGroupProps {
    item: {
        id?: string;
        type?: string;
        icon?: GenericCardProps['iconPrimary'];
        children?: NavGroupProps['item'][];
        title?: React.ReactNode | string;
        caption?: React.ReactNode | string;
        color?: 'primary' | 'secondary' | 'default' | undefined;
        divider?: boolean;
        sortable?: boolean
        onSort?: (ids: number[]) => void
        error?: boolean
    };
}

const NavGroup = ({ item }: NavGroupProps) => {
    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return null;
        }
    });

    return (
        <React.Fragment>
            <List className="menu"
                subheader={
                    item.title && (
                        <Typography variant="caption" className="menu-group-title" display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            {item.divider && <Divider className="menu-divider" />}
        </React.Fragment>
    );
};

export default NavGroup;
